/**
 * 埋点相关
 */
import { PlatformTypes } from '@/config/constMaps'
export default {
  methods: {
    gioMB13407() {
      this.$util.gioTrackWithVariable('MB13407', {
        // user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
        // member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
        productId_var: this.productId + '',
        page_stay_time: Date.now() - this.enterTime + '' || 'null',
      })
    },
    gioBD20114() {
      if (this.$util.isSyBird() || this.$util.isSyBirdH5()) {
        const gioParams = {
          store_id: this.o2oStoreId + '' || 'null',
          store_name: this.storeInfo?.o2OStoreName + '' || 'null',
          md_code: this.storeInfo?.mdCode + '' || 'null',
          md_name: this.storeInfo?.o2OStoreName + '' || 'null',
          fk_code: this.$route.query.fkcode ? this.$route.query.fkcode + '' : 'null',
          fc_code: this.$route.query.sceneCode ? this.$route.query.sceneCode + '' : 'null',
          scene_name: this.$route.query.planName ? this.$route.query.planName + '' : 'null',
          page_stay_time: ((Date.now() - this.enterTime) / 1000).toFixed(2) + '' || 'null',
          product_id: this.productId + '' || 'null',
          product_name: this.products?.productFullName + '' || 'null',
        }
        this.$util.gioTrackWithVariable('BD20114', gioParams)
      }
    },
    gioBD20271() {
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20271', {
          product_id: this.gioObject?.productId,
          content_id: this.cnxhClickItem?.productId,
          content_txt: this.cnxhClickItem?.productFullName,
          md_code: this.gioObject?.mdCode,
          store_id: this.gioObject?.storeId,
          origin: this.trkOrigin,
          site_number: this.cnxhClickItem.index,
        })
      }
    },
    gioHZ20017() {
      if (this.$util.isUplus()) {
        let params = {
          store_id: this.gioObject.storeId ? this.gioObject.storeId + '' : 'null',
          md_code: this.storeInfo?.mdCode ? this.storeInfo.mdCode + '' : 'null',
          product_id: this.gioObject?.productId ? this.gioObject?.productId + '' : 'null', // 产品id
          product_name: this.gioObject?.productName || 'null', // 产品名称
          site_number: this.$route.query?.traceIndex ? this.$route.query?.traceIndex + '' : 'null', // 编号
          page_stay_time: ((Date.now() - this.enterTime) / 1000).toFixed(2) || 'null', // 页面停留时长
        }
        this.$util.gioTrackWithVariable('HZ20017', params)
      }
    },
    /**
     * 内购底部按钮：客服、购物车、加入购物车、立即购买点击埋点
     */
    gioIH35363738(id) {
      this.$util.trackWithVariable({
        platformConf: {
          [PlatformTypes.INTERNAL_CHANNEL]: {
            id,
            param: ['product_id', 'product_name']
          },
        },
      },{
        product_id: this.gioObject.productId ? this.gioObject.productId + '' : 'null',
        product_name: this.gioObject.productName || 'null',
      }).then(res => {
        console.log('report res', res)
      })
    }
  },
}
